import { render, staticRenderFns } from "./table-enable-flag.vue?vue&type=template&id=a35fb9d6&scoped=true"
import script from "./table-enable-flag.vue?vue&type=script&lang=ts"
export * from "./table-enable-flag.vue?vue&type=script&lang=ts"
import style0 from "./table-enable-flag.vue?vue&type=style&index=0&id=a35fb9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35fb9d6",
  null
  
)

export default component.exports